import clsx from 'clsx'
import { useRef, useState } from 'react'
import Nav from 'react-bootstrap/Nav'
import Tab from 'react-bootstrap/Tab'
import { useIntl } from 'react-intl'
import { useQuery } from 'react-query'

import { TasksAPI } from '@api/tasksAPI'

import { TaskAssignModeEnum } from '@models/task'

import { MenuDropdown } from '@components/MenuDropdown'

import { QUERIES } from '@/constants/queries'
import { useBoolState } from '@/hooks'

import { TaskFloatingMenu } from '../TaskFloatingMenu'

const TaskListTopbar = () => {
  const intl = useIntl()
  const ref = useRef<HTMLButtonElement>(null)
  const [activeKey, setActiveKey] = useState<'all' | 'my-task'>('my-task')
  const [isShowDropdown, toggleDropdown, , hideDropdown] = useBoolState()

  const { data: total, refetch } = useQuery({
    cacheTime: 0,
    queryKey: [QUERIES.TASK_TODO_TOTAL],
    queryFn: () => TasksAPI.getTotal(),
    select: (r) => r.data?.total,
  })

  const isHasTodo = total !== undefined && total > 0

  return (
    <>
      <button
        ref={ref}
        type="button"
        className={clsx('btn btn-icon bg-body btn-color-gray-600 btn-active-color-primary h-40px', {
          'pulse pulse-primary': isHasTodo,
        })}
        onClick={toggleDropdown}
      >
        <i className="fa-solid fa-list-check fs-4" />

        {isHasTodo && (
          <>
            <span className="position-absolute top-15 start-100 translate-middle badge badge-circle badge-primary">
              {total}
              <span className="pulse-ring" />
            </span>
          </>
        )}
      </button>

      <MenuDropdown
        targetRef={ref}
        isShow={isShowDropdown}
        placement="bottom-end"
        width={350}
        onOuterClick={hideDropdown}
      >
        <Tab.Container activeKey={activeKey}>
          <div className="d-flex justify-content-between align-items-center px-7 pt-3 border-bottom">
            <h5 className="mb-1">{intl.formatMessage({ id: 'topbar_task.title' })}</h5>

            <Nav className="nav-line-tabs nav-stretch nav-line-tabs-2x fw-medium border-0">
              <Nav.Item>
                <Nav.Link
                  eventKey="my-task"
                  onClick={() => setActiveKey('my-task')}
                >
                  {intl.formatMessage({ id: 'topbar_task.my_task' })}
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  eventKey="all"
                  onClick={() => setActiveKey('all')}
                >
                  {intl.formatMessage({ id: 'topbar_task.all' })}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <Tab.Content>
            <Tab.Pane eventKey="my-task">
              <TaskFloatingMenu
                onlyActive
                enabled={isShowDropdown && activeKey === 'my-task'}
                taskAssignMode={TaskAssignModeEnum.AssignedToMe}
                onTaskUpdated={refetch}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="all">
              <TaskFloatingMenu
                onlyActive={false}
                taskAssignMode={null}
                enabled={isShowDropdown && activeKey === 'all'}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </MenuDropdown>
    </>
  )
}

export { TaskListTopbar }
